import { render } from "./trustee_view_dashboard.html?vue&type=template&id=8c8a9caa&external"
import script from "./trustee_view_dashboard.js?vue&type=script&lang=js&external"
export * from "./trustee_view_dashboard.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__